export enum BanType {
  Warn = 1,
  Ban = 2
}

export enum TargetType {
  Account = 1,
  Device = 2
}

export enum UserMemberTypeEnum {
  /**
   * 游客
   */
  Tourist = -1,
  /**
   * 学生
   */
  Student = 1,
  /**
   *  助教
   */
  TeachingAssistant = 2,
  /**
   * 助理
   */
  Assistant = 3,
  /**
   * 管理员
   */
  Admin = 4
}

export enum EnumAccountStatus {
  /** 正常 */
  Normal = 1,
  /** 禁用 */
  Ban = 2,
  /** 注销中 */
  Cancelling = 3,
  /** 已注销 */
  Cancelled = 4,
  /** 警告 */
  Warn = 5
}

export enum EnumLogoutType {
  /** 须知 */
  NOTICE = 'notice',
  /** 注销条件 */
  CONDITION = 'condition',
  /** 身份认证 */
  AUTH = 'auth',
  /** 检测账户 */
  ACCOUNT = 'account',
  /** 放弃资产 */
  ABANDON = 'abandon'
}

export enum EnumAbandonType {
  /** 放弃课程 */
  COURSE = 'course',
  /** 放弃虚拟资源 */
  RESOURCE = 'resource'
}

export enum EnumSexType {
  /** 男 */
  Man = 1,
  /** 女 */
  Woman = 2
}

// 1 手机验证码登录，2 邮箱验证码登录，3 绑定手机，4 绑定邮箱，5 更换手机，6 更换邮箱，7 手机找回密码，8 邮箱找回密码
export enum EnumVerifyCodeType {
  PhoneLogin = 1,
  EmailLogin = 2,
  BindPhone = 3,
  BindEmail = 4,
  ChangePhone = 5,
  ChangeEmail = 6,
  PhoneFindPassword = 7,
  EmailFindPassword = 8
}
